const fixedZero = (val: number) => {
  return val * 1 < 10 ? `0${val}` : val;
};

export default fixedZero;
